import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { TextField, Grid } from '@material-ui/core'
import AutocompleteNative from '@material-ui/lab/Autocomplete'
import { useSetorService } from 'hooks/useSetorService'
import { maxLengthAndNumber } from 'utils/helpers'
import useStyles from './FormDescricao.styles'

export const FormDescricao = (props) => {
  const { cadaverForm, errorNicExistente } = props
  const classes = useStyles()
  const setorService = useSetorService()
  const necroterios = useSelector((state) => state.setores.necroterios)

  useEffect(() => {
    if (!necroterios) {
      setorService.listarSetoresNecroterioGlobal()
    }
  }, [necroterios, setorService])

  const getMensagemErrorNic = (form, hasExistingError) => {
    if (form.hasError('nic')) {
      return form.formState.errors.nic[0]
    }
    if (hasExistingError) {
      return 'NIC já cadastrado'
    }
    return ''
  }

  return (
    <Grid className={classes.fieldGroup} alignItems="stretch" spacing={0} container justifyContent="space-between">
      <Grid className={classes.item} item md={2} sm={4} xs={12}>
        <TextField
          id="nic"
          fullWidth
          required
          label="NIC"
          name="NIC"
          variant="outlined"
          onChange={(event) => cadaverForm.handleChangeNewValueByNameProperty(event, maxLengthAndNumber(event.target.value, 6), 'nic')}
          value={cadaverForm.formState.values.nic || ''}
          InputLabelProps={{
            shrink: true,
            className: classes.labelInput,
          }}
          error={cadaverForm.hasError('nic') || errorNicExistente}
          helperText={getMensagemErrorNic(cadaverForm, errorNicExistente)}
        />
      </Grid>

      <Grid className={classes.item} item md={12} sm={12} xs={12}>
        <AutocompleteNative
          name="necroterio"
          noOptionsText="Sem informações"
          options={necroterios || []}
          value={cadaverForm.formState.values.necroterio}
          onChange={(event, newValue) => {
            cadaverForm.handleChangeNewValueByNameProperty(event, newValue, 'necroterio')
          }}
          getOptionSelected={(option, value) => option.id === value?.id || option.id === value || option === value}
          getOptionLabel={(option) => `${option.nome || ''} / ${option.divisao?.sigla || ''} / ${option.divisao?.regional?.sigla || ''}`}
          renderOption={(option) => `${option.nome || ''} / ${option.divisao?.sigla || ''} / ${option.divisao?.regional?.sigla || ''}`}
          renderInput={(params) => (
            <TextField
              {...params}
              label="NECROTÉRIO"
              required
              variant="outlined"
              InputLabelProps={{
                shrink: true,
                className: classes.labelInput,
              }}
            />
          )}
        />
      </Grid>
      <Grid className={classes.item} item md={12} sm={12} xs={12}>
        <AutocompleteNative
          name="causaJuridicaMortePreliminar"
          noOptionsText="Sem informações"
          options={['Acidente de tráfego', 'Afogamento', 'Homicídio por PAF', 'Homicídio por instrumento contundente', 'Homicídio por instrumento pérfuro-cortante', 'Homicídio por asfixia', 'Suicídio', 'Não informada']}
          value={cadaverForm.formState.values.causaJuridicaMortePreliminar || null}
          onChange={(event, newValue) => {
            cadaverForm.handleChangeNewValueByNameProperty(event, newValue, 'causaJuridicaMortePreliminar')
          }}
          getOptionSelected={(option, value) => option === value}
          getOptionLabel={(option) => `${option}`}
          renderOption={(option) => `${option}`}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              label="CAUSA DA MORTE - PRELIMINAR"
              required
              InputLabelProps={{
                shrink: true,
                className: classes.labelInput,
              }}
            />
          )}
        />
      </Grid>
      <Grid item md={12} sm={12} xs={12} className={classes.field}>
        <TextField
          id="descricaoGeral"
          error={cadaverForm.hasError('descricaoGeral')}
          fullWidth
          variant="outlined"
          helperText={cadaverForm.hasError('descricaoGeral') ? cadaverForm.formState.errors.descricaoGeral[0] : null}
          name="descricaoGeral"
          multiline
          label="DESCRIÇÃO GERAL"
          minRows={6}
          onChange={cadaverForm.handleChange}
          value={cadaverForm.formState.values.descricaoGeral || ''}
          required
          InputLabelProps={{
            shrink: true,
            className: classes.labelInput,
          }}
        />
      </Grid>
    </Grid>
  )
}

FormDescricao.propTypes = {
  cadaverForm: PropTypes.object.isRequired,
  errorNicExistente: PropTypes.bool,
}

